import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils/httpCommon";

interface MaintenanceStatus {
  enabled: boolean;
  error?: string;
}

const MAINTENANCE_CHECK_INTERVAL = 30000;

async function fetchMaintenanceStatus(): Promise<MaintenanceStatus> {
  const { data } = await http.get<MaintenanceStatus>(
    "/admin/api/maintenance/status"
  );
  return data;
}

const maintenanceKeys = {
  status: ["maintenanceStatus"] as const,
};

export function useMaintenanceStatus(enabled: boolean) {
  return useQuery({
    queryKey: maintenanceKeys.status,
    queryFn: fetchMaintenanceStatus,
    refetchInterval: MAINTENANCE_CHECK_INTERVAL,
    enabled,
    retry: false,
    staleTime: MAINTENANCE_CHECK_INTERVAL,
  });
}
